import announcementToManageListRedux from '../../views/list/redux/slice';


//export redux objects
export default {
	announcementToManageListRedux
};